import {
    difference as differenceFn,
    intersection as intersectionFn
} from "lodash-es";

export namespace array {
    /**
     * @description: 获取两个数组间差集
     * @param {string} arr1
     * @param {string} arr2
     * @return {*}
     */
    export function difference(arr1: string[], arr2: string[]) {
        return differenceFn(arr1, arr2);
    }

    /**
     * @description: 获取两个数组间交集
     * @param {string} arr1
     * @param {string} arr2
     * @return {*}
     */
    export function intersection(arr1: string[], arr2: string[]) {
        return intersectionFn(arr1, arr2);
    }
}
